import React from "react";
import { Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styles from "./Listings.module.css";
import FallbackImage from "../FallbackImage/FallbackImage";
import { API_BASE } from "../../../utils/api";

const Listings = ({ id, img, name, price, category, descriptor, likes, sales }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/dashboard/memory/${descriptor}`);
  };

  return (
    <Box className={styles.listingItem} onClick={handleClick}>
      <Box className={styles.listingImageContainer}>
        <FallbackImage className={styles.listingImage} src={`${API_BASE}${img}`} alt={name} />
        <Typography className={styles.listingName}>{name}</Typography>
      </Box>

      <Box className={styles.listingDetails}>
        <Box className={styles.detailColumn}>
          <Typography className={styles.detailHeading}>Category</Typography>
          <Typography className={styles.listingCategory}>
            {Array.isArray(category) && category.length > 0 ? category.join(", ") : "—"}
          </Typography>
        </Box>
        <Box className={styles.detailColumn}>
          <Typography className={styles.detailHeadingRight}>Price</Typography>
          <Typography className={styles.listingPrice}>${price.toLocaleString()}</Typography>
        </Box>
        <Box className={styles.detailColumn}>
          <Typography className={styles.detailHeadingRight}>Likes</Typography>
          <Typography className={styles.listingViews}>{likes.toLocaleString()}</Typography>
        </Box>
        <Box className={styles.detailColumn}>
          <Typography className={styles.detailHeadingRight}>Sales</Typography>
          <Typography className={styles.listingSales}>{sales.toLocaleString()}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

Listings.propTypes = {
  id: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  category: PropTypes.string.isRequired,
  descriptor: PropTypes.string.isRequired,
  views: PropTypes.number.isRequired,
  sales: PropTypes.number.isRequired,
};

export default Listings;